import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Box } from '@spothero/ui';
import SpotImages from 'common/spot-details/spot-images';
import FacilitySummary from 'common/facility-summary/v2';
import { useSelector } from 'react-redux';
import { getParkingType } from 'store/selectors';
import useDOMReady from 'common/search-results-map/google-map/use-domready';
import { InfoWindowCTA } from './GoogleMapInfoWindowCTA';
const priceLabelMap = {
    airport: '/day',
    event: 'subtotal',
    /* eslint-disable camelcase */
    event_package: '/event',
    power_booking: 'subtotal',
    /* eslint-enable camelcase */
    monthly: '/month',
    transient: 'subtotal',
};
const GoogleMapInfoWindow = ({ spot, onClick }) => {
    const { isReady: isDOMReady, container: parentContainer } = useDOMReady(spot);
    const [carouselHeight, setCarouselHeight] = useState(10);
    const state = useSelector((s) => s);
    const parkingType = getParkingType(state);
    const isBrowser = typeof window !== 'undefined';
    const checkoutUrl = spot?.selectedRate?.fullUrl;
    const isPowerBooking = state.searchRequest.powerBooking;
    const [container] = useState(() => isBrowser ? document.createElement('div') : null);
    const isMonthly = parkingType === 'monthly';
    const isAirport = parkingType === 'airport';
    const isToCheckout = !(isMonthly || isAirport);
    const handleClick = evt => {
        evt.stopPropagation();
        if (evt.target.dataset.testid === 'InfoWindowCTA-button' &&
            isToCheckout)
            return;
        return onClick(spot);
    };
    useEffect(() => {
        if (spot && isDOMReady && parentContainer) {
            parentContainer.appendChild(container);
            // remove unwanted focus on the Details button
            const timeoutHandle = setTimeout(() => {
                document.activeElement?.blur();
            }, 50);
            return () => {
                clearTimeout(timeoutHandle);
            };
        }
    }, [spot, parentContainer, container, isDOMReady]);
    // Set the carousel height to 6rem on devices with viewport width 375px (iPhone X/SE).
    useEffect(() => {
        const mediaQuery = window.matchMedia('(min-width: 375px) and (max-width: 375px)');
        function handleMediaQueryChange(event) {
            if (event.matches) {
                setCarouselHeight(6);
            }
        }
        mediaQuery.addEventListener('change', handleMediaQueryChange);
        handleMediaQueryChange(mediaQuery);
        return () => {
            mediaQuery.removeEventListener('change', handleMediaQueryChange);
        };
    }, []);
    // If we're server-side rendering, don't render anything.
    if (typeof window === 'undefined') {
        return null;
    }
    return ReactDOM.createPortal(spot ? (<Box data-testid="GoogleMapInfoWindow" maxWidth="250px" sx={{
            '& .FacilitySummary': {
                paddingX: '0px',
            },
        }}>
                {isDOMReady && spot.images?.length > 0 ? (<Box data-testid="GoogleMapInfoWindow-Images" sx={{
                '@media (max-width: 375px)': {
                    display: 'none',
                },
                '@media (min-width: 375px)': {
                    display: 'block',
                    '& .chakra-image': {
                        maxHeight: '10rem',
                    },
                },
                '@media (min-width: 375px) and (max-width: 375px)': {
                    maxHeight: '6rem',
                    '& .chakra-image': {
                        maxHeight: '6rem',
                    },
                },
                '@media (max-height: 570px)': {
                    display: 'none',
                },
            }}>
                        <SpotImages key={spot.spotId} images={spot.images} alt={spot.title} urlProperty="urlTemplate" carouselHeight={carouselHeight} reinitializeCarousel/>
                    </Box>) : null}
                <Box data-testid="GoogleMapInfoWindow-FacilitySummary" cursor="pointer" onClick={handleClick} sx={{
            '& .controls': {
                display: 'flex',
                justifyContent: 'flex-end',
            },
        }}>
                    <FacilitySummary 
    /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
    // @ts-ignore
    spot={spot} priceLabel={(parkingType && priceLabelMap[parkingType]) || ''} showPrice showImages={false} showFlair showCompactFlags isPowerBooking={isPowerBooking} CTAs={<InfoWindowCTA onClick={onClick} checkoutUrl={checkoutUrl} isToCheckout={isToCheckout}/>}/>
                </Box>
            </Box>) : null, container);
};
export default GoogleMapInfoWindow;
